/**
 * This file was automatically generated by `IconCodeGenerator`.
 * DO NOT MODIFY IT BY HAND. Instead, follow the instructions at `src/shared/joykit/packages/core/icons/README.md`.
 */

import * as React from 'react';

import createSvgIcon from '../createSvgIcon';

import { SvgIconConfig } from '../types';

const config: SvgIconConfig = {
  title: 'Download',
  definitions: {
    '16': {
      viewBox: '0 0 16 16',
      path: (
        <>
          <path
            d="M10.389 9.11029L8.38903 11.1103C8.17424 11.3251 7.826 11.3251 7.61121 11.1103L5.61121 9.11029C5.39643 8.8955 5.39643 8.54726 5.61121 8.33248C5.826 8.11769 6.17424 8.11769 6.38903 8.33248L7.45012 9.39357V1.83249C7.45012 1.52874 7.69637 1.28249 8.00012 1.28249C8.30388 1.28249 8.55012 1.52874 8.55012 1.83249V9.39357L9.61121 8.33248C9.826 8.11769 10.1742 8.11769 10.389 8.33248C10.6038 8.54726 10.6038 8.8955 10.389 9.11029Z"
            fill="currentColor"
          />
          <path
            d="M2.99453 6.72345C2.99453 5.92264 3.64372 5.27345 4.44453 5.27345H5.22231C5.52607 5.27345 5.77231 5.02721 5.77231 4.72345C5.77231 4.41969 5.52607 4.17345 5.22231 4.17345H4.44453C3.03621 4.17345 1.89453 5.31512 1.89453 6.72345V12.1679C1.89453 13.5762 3.0362 14.7179 4.44453 14.7179H11.5556C12.964 14.7179 14.1056 13.5762 14.1056 12.1679V6.72345C14.1056 5.31512 12.964 4.17345 11.5556 4.17345H10.7779C10.4741 4.17345 10.2279 4.41969 10.2279 4.72345C10.2279 5.02721 10.4741 5.27345 10.7779 5.27345H11.5556C12.3565 5.27345 13.0056 5.92264 13.0056 6.72345V12.1679C13.0056 12.9687 12.3565 13.6179 11.5556 13.6179H4.44453C3.64372 13.6179 2.99453 12.9687 2.99453 12.1679V6.72345Z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
};

const icon = createSvgIcon(config);
export default icon;
